import MoveDialog from './MoveDialog';
export default MoveDialog;
